import React, {useEffect, useState} from "react";
import cx from "classnames";

export function TextField(props: { value: string, onChange?: (value: string) => void, placeholder: string, className?: string, id: string, onChanged: (value: string) => void }) {

    const [myTimeout, setMyTimeout] = useState<NodeJS.Timeout | null>(null);

    const [value, setValue] = useState(props.value);
    useEffect(() => setValue(props.value), [props.value])

    return <input type="text" value={value}
                  id={props.id}
                  onChange={async (e) => {
                      setValue(e.target.value);
                      if (myTimeout) clearTimeout(myTimeout);
                      setMyTimeout(setTimeout(() => props.onChanged(e.target.value), 200));
                      if (props.onChange) props.onChange(e.target.value);
                  }}
                  placeholder={props.placeholder}
                  className={cx(
                      "w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm",
                      "placeholder:text-gray-400",
                      "focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500",
                      "dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-500",
                      props.className
                  )}
    />
}
